const swiper1 = new Swiper(".swiper-container1", {
  slidesPerView: 'auto',
  loop: true,
  centeredSlides: true,
  spaceBetween: 20,
  loopAdditionalSlides: 1,
  autoplay: {
    delay: 3000,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    1024: {
      slidesPerView: 'auto',
      spaceBetween: 40,
    }
  },
  pagination: {
    el: ".swiper-pagination",
    type: "fraction",
    formatFractionCurrent: function (number) {
      return number < 10 ? '0' + number : number;
    },
    formatFractionTotal: function (number) {
      return number < 10 ? '0' + number : number;
    },
    renderFraction: (currentClass, totalClass) => {
      return `<span class="${currentClass}"></span><span class="custom-slash"> / </span><span class="${totalClass}"></span>`;
    },
  },
  
});

const swiper2 = new Swiper(".swiper-container2", {
  slidesPerView: 'auto',
  loop: true,
  centeredSlides: true,
  spaceBetween: 20,
  loopAdditionalSlides: 1,
  autoplay: {
    delay: 3000,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    1024: {
      slidesPerView: 'auto',
      spaceBetween: 40,
      centeredSlides: false,
    }
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    // draggable: true,
  },
  pagination: {
    el: ".swiper-pagination",
    type: "fraction",
    formatFractionCurrent: function (number) {
      return number < 10 ? '0' + number : number;
    },
    formatFractionTotal: function (number) {
      return number < 10 ? '0' + number : number;
    },
    renderFraction: (currentClass, totalClass) => {
      return `<span class="${currentClass}"></span><span class="custom-slash"> / </span><span class="${totalClass}"></span>`;
    },
  },
  
});